// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// window.Pusher = Pusher;


// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_ABLY_PUBLIC_KEY,  // Use Ably public key
//     wsHost: 'realtime-pusher.ably.io',
//     wsPort: 443,
//     forceTLS: true,
//     disableStats: true,
//     encrypted: true,
// });


import Echo from '@ably/laravel-echo';
import * as Ably from 'ably';

window.Ably = Ably;
window.Echo = new Echo({
    broadcaster: 'ably',
});

// Test the connection on broadcast server
// window.Echo.connector.ably.connection.on(stateChange => {
//     if (stateChange.current === 'connected') {
//         console.log('connected to ably server');
//     }
// });
